import {
  STATES,
  FIND_VALUE_BY_SEARCHABLE,
} from "@hub/order/src/constants"
import {
  fillWithZeros
} from "@shared/helpers"
import {
  ADDRESS_TYPE,
  CONTACT_TYPE,
  PAYMENT_TYPE,
  PERSON_TYPE,
  SERVICES_TYPES,
} from "@hub/audit/src/constants"
import { SHIPPING_WHATSAPP } from "@hub/audit/src/constants"

import * as auditService from "@hub/audit/src/services/audit.service"
import * as addressService from "@hub/order/src/services/address.service"

export default {
  async fillAudit({ state, commit, rootGetters, dispatch }) {
    const { customer, services, invoice, coverage, credit, installation } = state.order

    await dispatch("Order/Contract/fetchContractOptionIfNecessary", null, { root: true })

    let complementsOptions = []

    let shippingOptions = rootGetters["Order/Contract/getShippingMethodsOptions"]
    let paymentOptions = rootGetters["Order/Contract/getPaymentTypesOptions"]

    try {
      const response = await addressService.fetchAddressComplements()
      complementsOptions = response.data
    } catch (error) {
      console.error("Erro ao buscar tipos de endereço secundário", error)
    }

    if (customer.type === "JURIDICA") {
      commit("updateClient", {
        cnpj: customer.legalPerson.cnpj,
        stateRegistration: customer.legalPerson.state_registration,
        exempt: !customer.legalPerson.state_registration,
        corporateName: customer.legalPerson.social_reason,
        corporateType: customer.legalPerson.person_legal_type,
        companyState: customer.legalPerson.state_id,
        legalRepresentative: customer.legalPerson.responsible.name,
        legalRepresentativeCpf: customer.legalPerson.responsible.cpf,
        email: customer.legalPerson.email,
        openingDate: customer.legalPerson.opening_date,
        motherName: customer.legalPerson.mother_name,
        fatherName: customer.legalPerson.father_name,
        landline: customer.legalPerson.landline || "",
        cellphone: customer.legalPerson.cellphone || "",
        anotherContact: customer.legalPerson.another_contact || "",
        isAnotherContactReturnedFilled: Boolean(customer.legalPerson.another_contact),
        whatsappContact: customer.legalPerson.whatsapp || "",
        city: customer.address.city,
        postcode: customer.address.postcode,
        address: customer.address.address,
        number: customer.address.number || "S/N",
        neighborhood: customer.address.neighborhood
      })
    }

    if (customer.type === "FISICA") {
      const isSchooled =
        customer.physicalPerson.schooled === null
          ? null
          : Boolean(customer.physicalPerson.schooled)

      commit("updateClient", {
        cpf: customer.physicalPerson.cpf,
        rg: customer.physicalPerson.rg,
        generalRegistrationExempt:
          customer.physicalPerson?.general_registration_exempt || false,
        fullName: customer.physicalPerson.name,
        email: customer.physicalPerson.email,
        birthDate: customer.physicalPerson.birthdate,
        motherName: customer.physicalPerson.mother_name,
        fatherName: customer.physicalPerson.father_name,
        gender: customer.physicalPerson.gender,
        profession: customer.physicalPerson.profession,
        maritalStatus: customer.physicalPerson.marital_status,
        landline: customer.physicalPerson.landline || "",
        cellphone: customer.physicalPerson.cellphone || "",
        anotherContact: customer.physicalPerson.another_contact || "",
        isAnotherContactReturnedFilled: Boolean(customer.physicalPerson.another_contact),
        whatsappContact: customer.physicalPerson.whatsapp || "",
        landlineType: customer.physicalPerson.landline_type,
        landlineParticularity: customer.physicalPerson.landline_particularity,
        schooled: isSchooled,
        city: customer.address.city,
        postcode: customer.address.postcode,
        address: customer.address.address,
        number: customer.address.number || "S/N",
        neighborhood: customer.address.neighborhood
      })
    }

    commit("updateClient", {
      typeClient: customer.type,
      secondaryAddress: {
        type: customer.address.complement?.type,
        text: customer.address.complement?.value,
        value: complementsOptions.find(
          type => type.label === customer.address.complement?.type
        )?.value
      },
      neighborhood: customer.address.neighborhood,
      state: STATES.find(state => state.text === customer.address.state.name)?.value
    })

    commit("updateClient", {
      typeClient: customer.type,
      condominiumComplement: {
        condominium_id: state.order.condominium_id || "",
        condominium_name: "",
        block: state.order.block || "",
        apartment: state.order.apartment || ""
      },
    })

    commit("updateProducts", services)

    commit("updateBilling", {
      dueDate: invoice.due_day,
      shipping: FIND_VALUE_BY_SEARCHABLE(
        shippingOptions,
        invoice.shipping_method
      ),
      whatsapp: invoice?.whatsapp,
      payment: FIND_VALUE_BY_SEARCHABLE(paymentOptions, invoice.payment_type),

      bank: invoice?.account_info?.bank_id,
      account: invoice?.account_info?.account,
      agency: invoice?.account_info?.agency,
      isSameAddress: customer.charge_address?.address ? 0 : 1
    })

    if (customer.charge_address?.address) {
      commit("updateBilling", {
        isSameAddress: 0,
        address: customer.charge_address.address,
        postcode: customer.charge_address.postcode,
        city: customer.charge_address.city.name,
        cityId: customer.charge_address.city.uuid,
        complements: customer.charge_address.complement || [],
        neighborhood: customer.charge_address.neighborhood,
        number: customer.charge_address.number,
        noNumber: customer.charge_address.number === null,
        state: customer.charge_address.state
      })
    }

    commit("updateContract", {
      sale_origin: state.order.sale_origin_uuid,
      wallet: state.order.wallet,
      contract_type: state.order.contract_type
    })

    if (coverage) {
      commit("updateCoverage", coverage)
    }

    if (credit) {
      commit("updateCredit", credit)
    }

    if (installation) {
      commit("updateInstallation", installation)
    }
  },

  resetBillingAddress({ commit }) {
    commit("updateBilling", {
      address: "",
      city: "",
      cityId: "",
      complements: [],
      neighborhood: "",
      number: "",
      noNumber: true,
      state: ""
    })
  },

  createComplement({ state, commit }, newComplement) {
    const complements = state.order?.customer?.address?.complement || []
    commit("updateCustomerAddress", { complement: [...complements, { ...newComplement }] })
  },

  deleteComplement({ state, commit }, indexComplement) {
    const complements = state.order?.customer?.address?.complement || []
    commit("updateCustomerAddress", {
      complement: complements.filter((complement, index) => index !== indexComplement)
    })
  },

  getServicesPayload({ state, getters }) {
    const services = []

    state.products.forEach(product => {
      if (product.status_id !== getters.statusRemoved) {
        if (product.entity === SERVICES_TYPES.plan) {
          const plan = getters.getPlanPayload(product)

          if (getters.getIsMobileWithMovements(product)) {
            const movement = getters.getMovementPayload(product)

            plan.plan = { ...plan.plan, movements: [movement] }
          } else if (getters.getIsPackageWithMovements(product)) {
            plan.plan = {
              ...plan.plan,
              movements: [...product.properties?.movements]
            }
          }

          services.push(plan)
        }

        if (product.entity === SERVICES_TYPES.serviceAdditional) {
          services.push(getters.getAdditionalServicePayload(product))
        }
      }
    })

    return services
  },

  hasBillingContractType({ state }) {
    return state.billing?.contractType?.value
  },

  getContractType({ state }) {
    if (state.order?.customer?.physicalPerson) {
      return state.order?.customer?.physicalPerson?.contact_type
    }

    return state.order?.customer?.legalPerson?.contact_type
  },

  async getCustomerPayload({ state, dispatch }) {
    const [
      contacts,
      physical,
      legal,
      contractType
    ] = await Promise.all([
      dispatch("getContactsPayload"),
      dispatch("getPhysicalPayload"),
      dispatch("getLegalPayload"),
      dispatch("getContractType"),
    ])

    return {
      person_type: state.order?.customer?.type,
      contacts,
      physical,
      legal,
      contact_type_uuid: contractType?.uuid
    }
  },

  async getContactsPayload({ dispatch }) {
    const contacts = await Promise.all([
      dispatch("getEmailContact"),
      dispatch("getCellphoneContact"),
      dispatch("getLandlineContact"),
      dispatch("getAnotherContact"),
      dispatch("getWhatsappNumberContact")
    ])

    return contacts.filter(contact => contact !== null)
  },

  getEmailContact({ state }) {
    if (!state.client?.email) {
      return null
    }

    return {
      type: CONTACT_TYPE.EMAIL,
      value: state.client?.email,
      particularity: state.client?.emailType
    }
  },

  getCellphoneContact({ state }) {
    if (!state.client?.cellphone) {
      return null
    }

    return {
      type: CONTACT_TYPE.CELLPHONE,
      value: state.client?.cellphone,
      phone_type: state.client?.cellPhoneType,
      particularity: state.client?.cellPhoneParticularity
    }
  },

  getLandlineContact({ state }) {
    if (!state.client?.landline) {
      return null
    }

    return {
      type: CONTACT_TYPE.LANDLINE,
      value: state.client?.landline,
      phone_type: state.client?.landlineType,
      particularity: state.client?.landlineParticularity
    }
  },

  getAnotherContact({ state }) {
    if (!state.client?.anotherContact) {
      return null
    }

    return {
      type: CONTACT_TYPE.ALTERNATIVE,
      value: state.client?.anotherContact?.replace(/\D/g, ""),
      phone_type: state.client?.anotherContactType,
      particularity: state.client?.anotherContactParticularity
    }
  },

  getWhatsappNumberContact({ state }) {
    if (!state.client?.whatsappContact) {
      return null
    }

    return {
      type: CONTACT_TYPE.WHATSAPP,
      value: state.client?.whatsappContact.replace(/\D/g, ""),
      phone_type: state.client?.whatsappContactType,
      particularity: state.client?.whatsappContactParticularity
    }
  },

  getPhysicalPayload({ state }) {
    if (!state.order.customer?.physicalPerson) {
      return {}
    }

    return {
      name: state.client?.fullName,
      birthdate: state.client?.birthDate,
      gender: state.client?.gender,
      mother_name: state.client?.motherName,
      father_name: state.client?.fatherName,
      general_registration: state.client?.rg || null,
      general_registration_exempt: state.client?.generalRegistrationExempt,
      profession_uuid: state.client?.profession || null,
      marital_status: state.client?.maritalStatus || null
    }
  },

  getLegalPayload({ state }) {
    if (!state.order?.customer?.legalPerson) {
      return {}
    }

    return {
      cnpj: state.client?.cnpj,
      social_reason: state.client?.corporateName,
      state_id: state.client?.companyState,
      opening_date: state.client?.openingDate,
      person_legal_type: state.client?.corporateType,
      state_registration: state.client?.stateRegistration,
      responsible: {
        name: state.client?.legalRepresentative,
        cpf: fillWithZeros(11, state.client?.legalRepresentativeCpf.toString())
      }
    }
  },

  getAddressPayload({ state }) {
    return {
      type: state.order?.customer?.type === PERSON_TYPE.LEGAL ? ADDRESS_TYPE.COMMERCIAL : ADDRESS_TYPE.RESIDENTIAL,
      address: state.order?.customer?.address?.address,
      city_uuid: state.order?.customer?.address?.city?.uuid,
      postcode: state.order?.customer?.address?.postcode,
      number: state.order?.customer?.address?.number,
      neighborhood: state.order?.customer?.address?.neighborhood,
      complement: state.order?.customer?.address?.complement || [],
    }
  },

  async getPaymentInfoPayload({ state, dispatch }) {
    const automatic_debit = await dispatch("getAutomaticDebitPayload")
    const whatsapp = await dispatch("getWhatsappPayload")

    const paymentInfo = {
      due_day: state.billing?.dueDate,
      payment_type: state.billing?.payment?.slug,
      shipping_method: state.billing?.shipping?.slug,
      whatsapp,
      automatic_debit
    }

    if (!state.billing.isSameAddress) {
      paymentInfo.address = await dispatch("getBillingAddressPayload")
    }

    return paymentInfo
  },

  getAutomaticDebitPayload({ state }) {
    if (state.billing?.payment?.slug !== PAYMENT_TYPE.DEBIT) {
      return {}
    }

    return {
      bank_id: state.billing?.bank,
      agency: state.billing?.agency,
      account: state.billing?.account
    }
  },

  getWhatsappPayload({ state }) {
    if (state.billing?.shipping?.slug !== SHIPPING_WHATSAPP.slug) {
      return ""
    }

    return state.billing?.whatsapp
  },

  getBillingAddressPayload({ state }) {
    return {
      type: state.order?.customer?.type === PERSON_TYPE.LEGAL ? ADDRESS_TYPE.COMMERCIAL : ADDRESS_TYPE.RESIDENTIAL,
      address: state.billing?.address,
      city_uuid: state.billing?.cityId,
      postcode: state.billing?.postcode,
      number: state.billing?.number,
      neighborhood: state.billing?.neighborhood,
      complement: state.billing?.complements
    }
  },

  getClientContractPayload({ state }) {
    if (state.order?.contract_id && state.order?.person_external_id) {
      return {
        contract_id: state.order?.contract_id,
        person_external_id: state.order?.person_external_id
      }
    }

    return {}
  },

  async getContractTypeValue({ state, dispatch }) {
    const HAS_BILLING_CONTRACT_TYPE = await dispatch("hasBillingContractType")

    if (HAS_BILLING_CONTRACT_TYPE) {
      return state.billing?.contractType?.value
    }

    return state.contract?.contract_type
  },

  async getFinishOrderPayload({ state, dispatch, getters }) {
    const [
      customer,
      address,
      paymentInfo,
      services,
      clientContract,
      contractType
    ] = await Promise.all([
      dispatch("getCustomerPayload"),
      dispatch("getAddressPayload"),
      dispatch("getPaymentInfoPayload"),
      dispatch("getServicesPayload"),
      dispatch("getClientContractPayload"),
      dispatch("getContractTypeValue")
    ])

    return {
      services,
      customer,
      address,
      ...clientContract,
      payment_info: paymentInfo,
      sale_origin_uuid: state.contract?.sale_origin,
      contract_type: contractType,
      wallet: state.contract?.wallet,
      client_type: state.billing?.clientType?.value,
      location_type: getters.orderCustomerTypeAddress,
      contract_model: state.billing?.contractModel?.value,
      reference_point: state.order?.reference_point,
      condominium_id: state.client?.condominiumComplement?.condominium_id,
      block: state.client?.condominiumComplement?.block,
      apartment: state.client?.condominiumComplement?.apartment
    };
  },

  async finishOrder({ state }, payload) {
    try {
      await auditService.finishAuditorship(state.order.uuid, payload)

      await window.$vue.$router.push({ name: "auditorship" })

      return true
    } catch (error) {
      throw error
    }
  }
}
